import { render, staticRenderFns } from "./batchPayModel.vue?vue&type=template&id=17259714&"
import script from "./batchPayModel.vue?vue&type=script&lang=js&"
export * from "./batchPayModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports